<p-panel [header]="'Process_Steps' | translateWF: 'Steps'">
  <p-card>
    <div class="col">
      <form [formGroup]="formGroup">
        <!-- Add Step Section -->
        @if (canEdit()) {
          <div class="add-step-section">
            <div class="form-box-row">
              <label for="stepToAdd">
                {{ 'Process_Add_Step' | translateWF: 'Add Step' }}
              </label>
              <p-autoComplete
                [formControl]="stepToAdd"
                [forceSelection]="true"
                [dropdown]="true"
                #stepSearch="cslServerSearch"
                [cslServerSearch]="fetchSteps"
                [suggestions]="stepSearch.results()"
                optionLabel="name.en"
                [placeholder]="'Search_Steps' | translateWF: 'Search steps...'"
              />
            </div>
          </div>
        }

        <!-- Steps List -->
        @for (stepControl of steps.controls; track stepControl.value.stepId; let i = $index) {
          @let step = stepControl.value;
          <div class="step-viewer-container bg-slate-100 p-4 rounded-md mb-4">
            <!-- Header: Step Name and Delete Button -->
            <div class="step-viewer-header">
              <h3 class="step-name">{{ getStepName(step) }}</h3>
              @if (canEdit()) {
                <p-button
                  icon="pi pi-trash"
                  variant="text"
                  [rounded]="true"
                  severity="danger"
                  (click)="removeStep(i)"
                  [pTooltip]="'Delete' | translateWF: 'Delete'"
                  tooltipPosition="left"
                />
              }
            </div>

            <div class="step-content">
              @if (step.additionalParameters && step.additionalParameters.length > 0) {
                <app-parameter-details-viewer [formControl]="getParametersControl(step)" [canEdit]="canEdit() && canEditParameters()" />
              }

              @if (step.itemDetails && step.itemDetails.length > 0) {
                <app-item-details-viewer
                  [itemDetailsFormGroups]="getItemDetailsFormGroupsForStep(step)"
                  [inventoryTypeReference]="inventoryTypeReference()"
                  [canEdit]="canEdit() && canEditItems()"
                />
              }
            </div>
          </div>
        }
      </form>

      @if (steps.length === 0) {
        <div class="empty-state">
          <p>
            {{ 'No_Steps_Added' | translateWF: 'No steps have been added yet.' }}
          </p>
        </div>
      }
    </div>
  </p-card>
</p-panel>
